import { Component, Inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';


@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './configuration-mode-confirmation-dialog.component.html',
  styleUrls: ['./configuration-mode-confirmation-dialog.component.scss']
})
export class ConfigurationModeConfirmationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfigurationModeConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {htmlContent: string, icon: string }) { }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
